import { createSlice } from '@reduxjs/toolkit';
import rollbackRequest from '@custom/rtk-apis/report/RollBackrequest';

export interface ReportState {
    loading: boolean;
    success: boolean;
    error: string | null;
  }

  const initialState: ReportState = {
    loading: false,
    success: false,
    error: null,
  };

  const reportSlice = createSlice({
    name: 'report',
    initialState,
    reducers: {
      resetReportState: (state) => {
        state.loading = false;
        state.success = false;
        state.error = null;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(rollbackRequest.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.success = false;
        })
        .addCase(rollbackRequest.fulfilled, (state) => {
          state.loading = false;
          state.success = true;
        })
        .addCase(rollbackRequest.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload as string;
          state.success = false;
        });
    },
  });

  export const { resetReportState } = reportSlice.actions;
  export default reportSlice.reducer;
